import React from "react";
import GridLines from "@/components/site/GridLines";

const PRODUCTS = [
  {
    id: "fcb",
    title: "Renaflex FCB",
    img: { d: "/assets/d-fcb.png", m: "/assets/m-fcb.png" },
    body: "The everyday fibre cement board for strong, clean and versatile construction. Ideal for partitions, ceilings, wall linings, backing boards, cladding and general board applications.",
    metaLeft: "Thickness",
    metaRight: "6 - 9 mm",
  },
  {
    id: "signa",
    title: "Renaflex Signa",
    img: { d: "/assets/d-hd.png", m: "/assets/m-hd.png" },
    body: "Renaflex HD is engineered through a repeated roller process that compresses board thickness to achieve higher density. The result is a board that works harder where ordinary boards may not be enough.",
    soon: "Coming soon...",
  },
  {
    id: "woodline",
    title: "Renaflex Woodline",
    img: { d: "/assets/d-woodline.png", m: "/assets/m-woodline.png" },
    body: "Designer fibre cement boards for surfaces that need character, pattern and visual expression. Ideal for feature walls, retail interiors, hospitality spaces, office design and architectural highlights.",
    soon: "Coming soon...",
  },
];

export default function Ranges() {
  return (
    <section className="rf-ranges" id="ranges" data-testid="ranges">
      <GridLines />
      <div className="rf-wrap">
        <div className="rf-ranges__head">
          <p className="rf-label">OUR RANGES</p>
          <h2 className="rf-h2">
            Renaflex is available across three product{" "}
            <br className="rf-br-d" />
            families, each designed for a different{" "}
            <br className="rf-br-d" />
            construction and design need.
          </h2>
        </div>
      </div>
      <div className="rf-ranges__rule" />
      <div className="rf-wrap">
        <div className="rf-ranges__grid">
          {PRODUCTS.map((p) => (
            <article className="rf-prod" key={p.id} data-testid={`product-${p.id}`}>
              <picture className="rf-prod__media">
                <source media="(max-width: 1023px)" srcSet={p.img.m} />
                <img src={p.img.d} alt={p.title} />
              </picture>
              <div className="rf-prod__copy">
                <h3 className="rf-prod__title">{p.title}</h3>
                <p className="rf-cardBody">{p.body}</p>
              </div>
              <div className="rf-prod__meta">
                {p.soon ? (
                  <span className="rf-prod__soon">{p.soon}</span>
                ) : (
                  <>
                    <span>{p.metaLeft}</span>
                    <span>{p.metaRight}</span>
                  </>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
      <div className="rf-ranges__rule" />
      <div className="rf-ranges__tail" />
    </section>
  );
}
